import { render } from "./ViewKitchenOrders.vue?vue&type=template&id=06d6725f&scoped=true"
import script from "./ViewKitchenOrders.vue?vue&type=script&lang=js"
export * from "./ViewKitchenOrders.vue?vue&type=script&lang=js"

import "./ViewKitchenOrders.vue?vue&type=style&index=0&id=06d6725f&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06d6725f"]])

export default __exports__